import React from 'react'
import { ReactComponent as InfoIcon } from 'assets/icons/info.svg'
import universityPng from 'assets/img/university.png'
import universityWebp from 'assets/img/university.webp'
import corporateIcon from 'assets/img/corporate.png'
import SelectDropdown from 'shared/ui/SelectDropdown/SelectDropdown'
import s from './styles/OrganizationEmptyState.module.scss'

export default function OrganizationEmptyState({
	options = [],
	value = '',
	onChange,
	disabled = false,
}) {
	return (
		<section className={s.card} aria-labelledby="um-org-empty-title">
			<div className={s.illustrationWrap}>
				<picture className={s.illustration}>
					<source srcSet={universityWebp} type="image/webp" />
					<img src={universityPng} alt="" aria-hidden="true" decoding="async" />
				</picture>
			</div>

			<h2 id="um-org-empty-title" className={s.title}>
				Select an organization
			</h2>
			<p className={s.subtitle}>
				Choose an organization to view and manage students and counsellors.
			</p>

			<div className={s.selectWrap}>
				<img src={corporateIcon} alt="" aria-hidden="true" className={s.selectIcon} />
				<SelectDropdown
					value={value}
					onChange={onChange}
					options={options}
					disabled={disabled}
					placeholder="Select organization"
					showActiveCheck
					highlightActiveBackground
					fullWidth
					menuZIndex={3000}
				/>
			</div>

			<div className={s.infoBanner} role="note">
				<span className={s.infoIcon} aria-hidden="true">
					<InfoIcon />
				</span>
				<p className={s.infoText}>
					As a platform admin, you can manage users across all organizations.
				</p>
			</div>
		</section>
	)
}
